angular.module('core')
  .service('reportErrors', [function() {
      var self = this;

      self.getErrorMessage = function(error, defaultMsg) {
        console.log('inside error service ' + error);
        if (error && error.data && error.data.code) {
            switch (error.data.code) {
                case 6000:
                    return 'No data exists for the academic standard and time period selected.';
            }
        }

        if (defaultMsg) {
            return defaultMsg;
        }

        return null;
      };


      return this;
  }]);
